import type { consents as en } from '@/i18n/locales/en/consents';
import type { Translation } from '@/i18n/types';

export const consents: Translation<typeof en> = {
  title: 'Os teus consentimentos',
  empty: 'Nenhum pedido de consentimento te diz respeito.',
  collectiveNote:
    'Está em vigor um registo coletivo no departamento; a tua resposta pessoal não tem efeito enquanto este se mantiver.',
  table: {
    department: 'Departamento',
    status: 'Estado',
    basis: 'Base em vigor',
  },
  status: {
    pending: 'A aguardar a tua resposta',
    granted: 'Concedido',
    denied: 'Recusado',
  },
  basis: {
    personal: 'Pessoal',
    collective: 'Coletiva',
  },
  actions: {
    grant: 'Conceder',
    deny: 'Recusar',
    withdraw: 'Retirar',
  },
};
